<script lang="ts">
  import { onMount } from 'svelte';
  import Cookies from 'js-cookie';
  import type { FormField } from '../types';
  import pwtHelper from '$lib/helpers/browser/pwt-helper';
  import {
    INCOMINGURL_COOKIE_NAME,
    PLAN_GROUP_TOKEN_COOKIE_NAME,
    RSCODE_COOKIE_NAME,
    SAASQUATCH_COOKIE_NAME,
  } from '$lib/constants/cookie-constants';

  export let field: FormField;
  let value: string | null = field.autofillValue || '';

  const setHiddenFieldValue = () => {
    if (field.id === 'Square_AVT__c') {
      value = Cookies.get('_savt') || '';
    } else if (field.id === 'referrer') {
      value = document.location.href;
      // @ts-expect-error  has an 'any'
    } else if (field.autoFill?.valueFrom === 'query') {
      // @ts-expect-error  has an 'any'
      value = new URL(document.location.href).searchParams.get(field.autoFill?.parameterName) || '';
    } else if (field.id === 'cookieAffiliate') {
      value = Cookies.get(SAASQUATCH_COOKIE_NAME) || null;
    } else if (field.id === 'cookieCode') {
      value = Cookies.get(RSCODE_COOKIE_NAME) || null;
    } else if (field.id === 'cookieEntireURL') {
      value = Cookies.get(INCOMINGURL_COOKIE_NAME) || null;
    } else if (field.id === 'experiments') {
      const planGroupToken = Cookies.get(PLAN_GROUP_TOKEN_COOKIE_NAME);
      // Check for the existence of the P&P cookie
      if (planGroupToken !== undefined) {
        value = value ? `${value}, ${planGroupToken}` : planGroupToken;
      }
    }
  };

  onMount(async () => {
    setHiddenFieldValue();
    /*
      Saasquatch query params to cookie setting in PWS tracking.js might happen after the lead form has been initialized. 
      So we need to listen for the event that is fired when the cookies are set and then update the hidden fields again.
    */
    if (['cookieAffiliate', 'cookieCode', 'cookieEntireURL'].includes(field.id)) {
      const MARKETING_AFFILIATE_COOKIES_SET: Sq.Tracking.ObserverName = 'sq:marketingCookiesSet';
      pwtHelper.subscribeDependents();
      window.Sq.Tracking.subscribe(MARKETING_AFFILIATE_COOKIES_SET, () => {
        setHiddenFieldValue();
      });
    }
  });
</script>

<input class="fs-exclude" id={field.id} name={field.id} type="hidden" bind:value />
